import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import Dashboard from '../../Dashboard/index';
import { fetchCustomersRoutine, removeCustomerRoutine, fetchEmployeesPromise } from '../../../redux/routines';

import styles from './styles';
import { hasPermission } from '../../../utils/authenticated';
import { showDialog, hideDialog, showConfirm } from '../../../redux/actions/dialogs';
import { isDialogVisibleSelector } from '../../../redux/selectors';
import { CUSTOMER_DIALOG } from '../../../redux/constants/dialogs';
import CustomersGrid from '../CustomersGrid/index';

class Customers extends Component {
  componentWillMount() {
    console.log('hasPerm', hasPermission(['JobCreator', 'Administrator']));

    this.setState({
      editable: hasPermission(['JobCreator', 'Administrator']),
    });
  }

  handleAdd = () => {
    this.props.showDialog(CUSTOMER_DIALOG, { customer: {} });
  };

  handleEdit = (customer) => {
    this.props.showDialog(CUSTOMER_DIALOG, { customer });
  };

  handleRemove = (customer) => {
    return this.handleRemoveCustomers([customer]);
  };

  handleRemoveCustomers = (customers) => {
    return new Promise((resolve, reject) => {
      const message = `Are you sure you wish to remove the ${customers.length > 1 ? customers.length : ''} 
      selected ${customers.length > 1 ? 'customers' : 'customer'}?`;
      this.props.showConfirm({
        title: message,
        onConfirm: () => {
          Promise.all(customers.map((customer) => this.props.removeCustomer(customer)))
            .then(() => {
              console.log('customers deleted');
              resolve();
            });
        },
        onReject: reject,
      });
    });
  };

  render() {
    const { customers, fetchCustomers, showDialog, hideDialog, fetchEmployees } = this.props;
    const { editable } = this.state;

    return (
      <Dashboard title="Customers" style={styles.wrapper}>

        <div style={styles.wrapper}>
          <CustomersGrid
            data={customers}
            fetch={fetchCustomers}
            onAdd={editable ? this.handleAdd : null}
            onEdit={editable ? this.handleEdit : null}
            onRemove={editable ? this.handleRemove : null}
            showDialog={showDialog}
            hideDialog={hideDialog}
            fetchEmployees={fetchEmployees}
          />
        </div>
      </Dashboard>
    );
  }
}

Customers.propTypes = {
  fetchCustomers: PropTypes.func.isRequired,
  removeCustomer: PropTypes.func.isRequired,
  customers: PropTypes.object.isRequired,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchCustomers: fetchCustomersRoutine.trigger,
      removeCustomer: removeCustomerRoutine.trigger,
      showDialog,
      hideDialog,
      showConfirm,
    }, dispatch),
    ...bindPromiseCreators({
      fetchEmployees: fetchEmployeesPromise,
    }, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    customers: state.getIn(['customers', 'customers']).toJS(),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Customers);



// WEBPACK FOOTER //
// ./src/components/Customers/CustomersView/index.js